import { Api } from "./api"

export function isEmpty(value) {
  return (
    value && value.constructor === Object && Object.keys(value).length === 0
  )
}

export function onChange(fn) {
  return (e) => {
    return fn(e.target.value)
  }
}

// TODO(shakefu): samesies
export function onEnter(fn) {
  return (e) => {
    if (e.key !== "Enter") return
    fn()
  }
}

//Will need to be updated once we have a full release product
export function getEnvironment() {
  const fullUrl = window.location.href
  if (fullUrl.includes("demo")) {
    return "Demo"
  } else if (fullUrl.includes("beta") || fullUrl.includes("local")) {
    return "Beta"
  } else {
    return ""
  }
}

// Unroll a error Promise or error Object into a human readable message.
export async function unrollError(error) {
  if (error instanceof Error) {
    return error.message
  }
  const payload = await error.json()
  if (payload.detail) {
    return payload.detail
  }
  if (payload.error) {
    return payload.error
  }
  // Fallback to the raw JSON error
  return JSON.stringify(payload)
}

// Create a Stripe customer for the user without waiting for the response.
export async function createStripeCustomer() {
  const api = new Api()
  try {
    const resp = await api.stripeCreateCustomer()
    console.log("Stripe customer created", resp)
  } catch (error) {
    console.error("Failed to create Stripe customer", error)
  }
}

export const generateBreadcrumbs = (
  path,
  config,
  breadcrumbs = [],
  params = {},
  data = {},
) => {
  const segments = path.split("/").filter(Boolean)
  let currentConfig = config
  let currentPath = ""
  let isRoot = true

  for (const segment of segments) {
    currentPath += `/${segment}`

    let configSegment = null
    if (isRoot) {
      configSegment = currentConfig[segment]
      isRoot = false
    } else if (currentConfig?.children) {
      if (
        Object.prototype.hasOwnProperty.call(currentConfig.children, segment)
      ) {
        configSegment = currentConfig.children[segment]
      } else {
        const dynamicEntry = Object.entries(currentConfig.children).find(
          ([key]) => key.startsWith(":"),
        )
        if (dynamicEntry) {
          configSegment = dynamicEntry[1]
        }
      }
    }

    if (!configSegment) break

    const label =
      typeof configSegment.label === "function"
        ? configSegment.label(params, data)
        : configSegment.label
    breadcrumbs.push({
      label,
      path: currentPath,
      current: currentPath === location.pathname,
    })

    currentConfig = configSegment
  }
  return breadcrumbs
}
